import React, { Fragment, Component } from 'react'
import {
    Container,
    Row, Col,
    CardBody, Card, CardTitle, CardSubtitle,
    Button,
    Input,
    Label,
    FormGroup, CustomInput
} from "reactstrap"
import { ConfirmAlert } from '../../../../helpers/ui/alert'
import { AvForm, AvGroup, AvInput, AvField, AvCheckboxGroup, AvCheckbox } from "availity-reactstrap-validation"
import Select from "react-select"

import { Link, useHistory, Redirect } from "react-router-dom"
import { withRouter } from "react-router";

import apiResponse from '../../../../services/apiResponse'
import moment from "moment"
import ApproveBloc from './Blocs/ApproveBloc'
import PegawaiSideBar from '../../GlobalComponents/PegawaiSidebar'
import CustomSelect from '../../GlobalComponents/CustomSelect'
import { FileInput, generateFormData } from '../../../../helpers/ui/FileInput'

import { accessRole } from '../../../../helpers/access_role'

// const peg_uuid = JSON.parse(localStorage.getItem('userdata'))?.employee_uuid ?? "";
// const peg_nip = JSON.parse(localStorage.getItem('userdata'))?.employee_nip ?? "";


var reformatOptionRegion = function(regions) {
  return regions.map(function(region) {
    var newObj = {};
    newObj["label"] = region.region_name;
    newObj["value"] = region.region_uuid;

    return newObj;
  });
};

var reformatOptions = function(raw, label, value) {
    return raw.map(function(data) {
      var newObj = {};
      newObj["label"] = data[label];
      newObj["value"] = data[value];
  
      return newObj;
    });
  };
  const dateParse = (input) =>{
    let res = "-";
    if (input != "" && input != null){
      res = moment(input).format('DD/MM/YYYY')
    }
    return res;
}

class IndexView extends Component {

    approveBloc = new ApproveBloc();

    userdata = JSON.parse(localStorage.getItem('userdata'));
    employeeSeleted = JSON.parse(localStorage.getItem('employeeSelected'));
    peg_uuid = !accessRole('approve') ? (this.userdata != null ? this.userdata.employee_uuid : "") 
    : (this.employeeSeleted != null ? this.employeeSeleted.employee_uuid : "")
    peg_nip = !accessRole('approve') ? (this.userdata != null ? this.userdata.employee_nip : "") 
    : (this.employeeSeleted != null ? this.employeeSeleted.employee_nip : "")

    constructor(props) {
        super(props)
        this.state = {
            dataForm: {},
            logdataForm: {},
            optionGender : [
                { label: "Dinas Luar", value: "Dinas Luar" },
                { label: "Di Kantor", value: "Di Kantor" }
            ],
            optionNational : [
                { label: "Dalam Negeri", value: "Dalam Negeri" },
                { label: "Luar Negeri", value: "Luar Negeri" }
              ],
            selectedGender: "",
            birthSelectedCountry: "444fbff9-52d6-4d61-9150-b5060055e560", // Kepala Perpu
            birthOptionCountry : [],
            birthOptionProvince : [],
            birthSelectedProvince: "",
            birthOptionCity : [],
            detail: [],
            birthSelectedCity: "",
            optionStatusApproval : [
                { label: "Disetujui", value: 1 },
                { label: "Ditolak", value: 2 }
              ],
        }
    }

    // Select Area

    handleBirthSelectNationality = (birthSelectNationality) => {
        let selected = birthSelectNationality.value;
        if (selected == "Dalam Negeri") {
            this.setState({
                birthSelectedCountry: "444fbff9-52d6-4d61-9150-b5060055e560",
                isLocal: 1
            })
        } else {
            this.setState({
                birthSelectedCountry: "",
                isLocal: 0
            })
        }
    }

    handleBirthSelectCountry = (birthSelectedCountry) => {
        let selected = birthSelectedCountry.value;
        this.getBirthProvinceByCountry(selected);
    }

    getBirthProvinceByCountry(selected_uuid){
        this.approveBloc.regionProvinceChannel.subscribe((result) => {
            switch (result.status) {
                case apiResponse.COMPLETED:
                    if(result.data.status) {
                        let response = result.data.response
                        //console.log(response)

                        this.setState({
                            birthOptionProvince: reformatOptions(
                                response.result, 
                                'signatories_official_position',
                                'signatories_official_uuid'
                            )
                        })
                    }
                    break
                case apiResponse.ERROR:
                    
                    break
                default:
                    break
            }
        })
        this.approveBloc.fetchRegionProvince({
          //is_local: 1,
          parent_uuid : selected_uuid,
          type : 2  
        })
    }

    handleBirthSelectProvince = (birthSelectedProvince) => {
      this.setState({
        birthSelectedProvince: birthSelectedProvince.value
      });

      // get data city where province selected
      this.approveBloc.regionCityChannel.subscribe((result) => {
          switch (result.status) {
              case apiResponse.COMPLETED:
                  if(result.data.status) {
                      let response = result.data.response
                      //console.log(response)
                      
                      this.setState({
                          birthOptionCity: reformatOptionRegion(response.result)
                      })
                  }
                  break
              case apiResponse.ERROR:
                  
                  break
              default:
                  break
          }
      })
      this.approveBloc.fetchRegionCity({
        is_local: 1,
        type : 3,
        parent_uuid : birthSelectedProvince.value
      })
    }

    handleBirthSelectCity = (birthSelectedCity) => {
      this.setState({
        birthSelectedCity: birthSelectedCity.value
      });
    }

    handleSelectGender = (selectedGender) => {
        this.setState({
            selectedGender: selectedGender.value
        });
    }

    // End Select Area

    submitData = async () => {
        const formData = generateFormData(this.state.dataForm, ['file','file_pernyataan_pelantikan','file_pakta','file_jabatan','file_tugas'])
        await this.approveBloc.fetchApprove(formData)
    }

    handlerOnSubmit = (e, values) => {
        e.preventDefault()
        this.setState({
            dataForm: {
                ...values
            },
            confirm: true
        })
    }

    confirmResponse = (response) => {
        let forState = {}
        switch(response) {
            case 'cancel':
                forState = {
                    confirm: false
                }
                break;
            case 'confirm':
                forState = {
                    loading: true,
                    confirm: false
                }
                this.submitData()
                break;
            case 'success':
                forState = {
                    success: false,
                    redirect: true
                }
                break;
             case 'failed':
                forState = {
                    failed: false
                }
                break;
            default:       
        }
        this.setState(forState)
    }
    

    componentDidMount() {
        this.approveBloc.approveChannel.subscribe((result) => {
            switch (result.status) {
                case apiResponse.COMPLETED:
                    this.setState({
                        loading: false,
                        success: true,
                    });
                    break
                case apiResponse.ERROR:
                    this.setState({
                        loading: false,
                        failed: true,
                    });
                    break
                default:
                    break
            }
        })

        this.approveBloc.detailChannel.subscribe((result) => {
            switch (result.status) {
                case apiResponse.COMPLETED:
                    if(result.data.status) {
                        let response = result.data.response
                        console.log(response);
                        this.setState({
                            dataForm: {
                              uuid: response.new?.swear_history_uuid,
                              employee_uuid: response.new?.swear_history_employee_uuid,
                              swear_history_no: response.new?.swear_history_no,
                              swear_history_date: response.new?.swear_history_date,
                              swear_history_description: response.new?.swear_history_description,
                            //   documents_name: response.new?.documents_name,
                            //   documents_path: response.new?.documents_path,
                                swear_history_inaguration_number:response.new?.swear_history_inaguration_number,
                                swear_history_inaguration_date:response.new?.swear_history_inaguration_date,
                                swear_history_pact_date:response.new?.swear_history_pact_date,
                                swear_history_duty_number:response.new?.swear_history_duty_number,
                                swear_history_duty_date:response.new?.swear_history_duty_date,
                                swear_history_execute_number:response.new?.swear_history_execute_number,
                                swear_history_execute_date:response.new?.swear_history_execute_date,
                                swear_history_document_path:response.new?.swear_history_document_path,
                                swear_history_inaguration_doc_path:response.new?.swear_history_inaguration_doc_path,
                                swear_history_duty_doc_path:response.new?.swear_history_duty_doc_path,
                                swear_history_execute_doc_path:response.new?.swear_history_execute_doc_path,

                            },
                            logdataForm: {
                              uuid: response.old?.swear_history_uuid,
                              employee_uuid: response.old?.swear_history_employee_uuid,
                              swear_history_no: response.old?.swear_history_no,
                              swear_history_date: response.old?.swear_history_date,
                              swear_history_description: response.old?.swear_history_description,
                            //   documents_name: response.old?.documents_name,
                            //   documents_path: response.old?.documents_path,
                                swear_history_inaguration_number:response.old?.swear_history_inaguration_number,
                                swear_history_inaguration_date:response.old?.swear_history_inaguration_date,
                                swear_history_pact_date:response.old?.swear_history_pact_date,
                                swear_history_duty_number:response.old?.swear_history_duty_number,
                                swear_history_duty_date:response.old?.swear_history_duty_date,
                                swear_history_execute_number:response.old?.swear_history_execute_number,
                                swear_history_execute_date:response.old?.swear_history_execute_date,
                                swear_history_document_path:response.old?.swear_history_document_path,
                                swear_history_inaguration_doc_path:response.old?.swear_history_inaguration_doc_path,
                                swear_history_duty_doc_path:response.old?.swear_history_duty_doc_path,
                                swear_history_execute_doc_path:response.old?.swear_history_execute_doc_path,

                            },
                        })
                    }
                    break
                case apiResponse.ERROR:
                    
                    break
                default:
                    break
            }
        })
        const queryParams = new URLSearchParams(this.props.location.search)
        this.approveBloc.fetchDetail({uuid: queryParams.get('uuid') })

         // get data birth country
         this.approveBloc.regionCountryChannel.subscribe((result) => {
            switch (result.status) {
                case apiResponse.COMPLETED:
                    if(result.data.status) {
                        let response = result.data.response
                        //console.log(response)

                        this.setState({
                            birthOptionCountry: reformatOptions(
                                response.result, 
                                'signatories_official_position',
                                'signatories_official_uuid'
                            )
                        })
                    }
                    break
                case apiResponse.ERROR:
                    
                    break
                default:
                    break
            }
        })
        this.approveBloc.fetchRegionCountry({
          type : 1  
        })

        // get data birth province
        this.getBirthProvinceByCountry(this.state.birthSelectedCountry);

        // get data province
          this.approveBloc.regionProvinceChannel.subscribe((result) => {
            switch (result.status) {
                case apiResponse.COMPLETED:
                    if(result.data.status) {
                        let response = result.data.response
                        //console.log(response)
                        
                        this.setState({
                            birthOptionProvince: reformatOptionRegion(response.result)
                        })
                    }
                    break
                case apiResponse.ERROR:
                    
                    break
                default:
                    break
            }
        })
        this.approveBloc.fetchRegionProvince({
          is_local: 1,
          type : 2  
        })

        // get data city where province selected
        this.approveBloc.regionCityChannel.subscribe((result) => {
            switch (result.status) {
                case apiResponse.COMPLETED:
                    if(result.data.status) {
                        let response = result.data.response
                        //console.log(response)
                        
                        this.setState({
                            birthOptionCity: reformatOptionRegion(response.result)
                        })
                    }
                    break
                case apiResponse.ERROR:
                    
                    break
                default:
                    break
            }
        })
        this.approveBloc.fetchRegionCity({
          is_local: 1,
          type : 3,
          parent_uuid : this.state.birthSelectedProvince
        })
      
    }

    render() {
        const { result, detail } = this.state.detail
        return (
            <Fragment>
                <Container fluid>
                    <Row>
                        <Col className="col-12">

                            <PegawaiSideBar active="riwayatsumpah"/>

                            <Card className="pegawai-rightbar">
                                <CardBody>
                                    <CardTitle>Detail Data Dokumen Pelantikan</CardTitle>
                                    <CardSubtitle className="mb-3">
                                        {/* Setiap isian yang bertanda (<span className="text-danger">*</span>) adalah wajib diisi. */}
                                    </CardSubtitle>
                                    <hr />
                                    <AvForm
                                        className="needs-validation"
                                        onValidSubmit={(e, values) => this.handlerOnSubmit(e, values)}
                                    >

                                      {/* Masih HardCode */}
                                      <AvField
                                            name="uuid"
                                            type="hidden"
                                            id="uuid"
                                            value={this.state.dataForm.uuid}
                                      />
                                      <AvField
                                            name="employee_uuid"
                                            type="hidden"
                                            id="employee_uuid"
                                            value={this.state.dataForm.employee_uuid}
                                      />
                                      <AvField
                                            name="employee_nip"
                                            type="hidden"
                                            id="employee_nip"
                                            value={this.peg_nip}
                                      />
                                      {/* Sampai Sini */}

                                    
                                        <Row className="mb-3">
                                            <label
                                                htmlFor="name"
                                                className="col-md-3 col-form-label"
                                            >
                                            Tanggal Berita Acara Pelantikan <span className="text-danger">*</span>
                                            </label>
                                            <Col md="5">
                                                {dateParse(this.state.dataForm.swear_history_date)}
                                            </Col>
                                            
                                        </Row>

                                        
                                        <Row className="mb-3">
                                            <label
                                                htmlFor="name"
                                                className="col-md-3 col-form-label"
                                            >
                                                Dokumen Berita Acara Pelantikan 
                                            </label>
                                            <Col md="5">
                                            {this.state.dataForm?.swear_history_document_path?<a href={this.state.dataForm?.swear_history_document_path} className='btn btn-success btn-sm' target={'_blank'} download><i class="uil-download-alt"></i> Download</a>:'-'}
                                            </Col>
                                        
                                        </Row>
                                        {/* B */}
                                        <Row className="mb-3">
                                            <label
                                                htmlFor="name"
                                                className="col-md-3 col-form-label"
                                            >
                                            Nomor Surat Pernyataan Pelantikan 
                                            </label>
                                            <Col md="5">
                                                {this.state.dataForm.swear_history_inaguration_number}
                                            </Col>
                                           
                                        </Row>
                                        <Row className="mb-3">
                                            <label
                                                htmlFor="name"
                                                className="col-md-3 col-form-label"
                                            >
                                            Tanggal Surat Pernyataan Pelantikan 
                                            </label>
                                            <Col md="5">
                                                {dateParse(this.state.dataForm.swear_history_inaguration_date)}
                                            </Col>
                                            
                                        </Row>
                                        <Row className="mb-3">
                                            <label
                                                htmlFor="name"
                                                className="col-md-3 col-form-label"
                                            >
                                                Dokumen Upload Surat Pernyataan Pelantikan 
                                            </label>
                                            <Col md="5">
                                            {this.state.dataForm?.swear_history_inaguration_doc_path?<a href={this.state.dataForm.swear_history_inaguration_doc_path?.swear_history_inaguration_doc_path} className='btn btn-success btn-sm' target={'_blank'} download><i class="uil-download-alt"></i> Download</a>:'-'}
                                            </Col>
                                            
                                        </Row>
                                        
                                        {/* C */}
                                        <Row className="mb-3">
                                            <label
                                                htmlFor="name"
                                                className="col-md-3 col-form-label"
                                            >
                                            Tanggal Pakta Integritas 
                                            </label>
                                            <Col md="5">
                                                {dateParse(this.state.dataForm.swear_history_pact_date)}
                                            </Col>
                                            
                                        </Row>
                                        <Row className="mb-3">
                                            <label
                                                htmlFor="name"
                                                className="col-md-3 col-form-label"
                                            >
                                                Dokumen Upload Pakta Integritas
                                            </label>
                                            <Col md="5">
                                            {this.state.dataForm.dataForm?.swear_history_duty_doc_path?<a href={this.state.dataForm?.swear_history_duty_doc_path} className='btn btn-success btn-sm
 btn-sm' target={'_blank'} download><i class="uil-download-alt"></i> Download</a>:'-'}
                                            </Col>
                                            
                                        </Row>

                                        {/* D */}
                                        <Row className="mb-3">
                                            <label
                                                htmlFor="name"
                                                className="col-md-3 col-form-label"
                                            >
                                            Nomor Surat Pernyataan Menduduki Jabatan 
                                            </label>
                                            <Col md="5">
                                                {this.state.dataForm.swear_history_duty_number}
                                            </Col>
                                            
                                        </Row>
                                        <Row className="mb-3">
                                            <label
                                                htmlFor="name"
                                                className="col-md-3 col-form-label"
                                            >
                                            Tanggal Surat Pernyataan Menduduki Jabatan 
                                            </label>
                                            <Col md="5">
                                                {dateParse(this.state.dataForm.swear_history_duty_date)}
                                            </Col>
                                           
                                        </Row>
                                        <Row className="mb-3">
                                            <label
                                                htmlFor="name"
                                                className="col-md-3 col-form-label"
                                            >
                                                Dokumen Upload Surat Pernyataan Menduduki Jabatan 
                                            </label>
                                            <Col md="5">
                                            {this.state.dataForm?.swear_history_duty_doc_path?<a href={this.state.dataForm?.swear_history_duty_doc_path} className='btn btn-success btn-sm
 btn-sm' target={'_blank'} download><i class="uil-download-alt"></i> Download</a>:'-'}
                                            </Col>
                                            
                                        </Row>
                                        {/* E */}
                                        <Row className="mb-3">
                                            <label
                                                htmlFor="name"
                                                className="col-md-3 col-form-label"
                                            >
                                            Nomor Surat Pernyataan Melaksanakan Tugas
                                            </label>
                                            <Col md="5">
                                                {this.state.dataForm.swear_history_execute_number}
                                            </Col>
                                           
                                        </Row>
                                        <Row className="mb-3">
                                            <label
                                                htmlFor="name"
                                                className="col-md-3 col-form-label"
                                            >
                                            Tanggal Surat Pernyataan Melaksanakan Tugas 
                                            </label>
                                            <Col md="5">
                                                {dateParse(this.state.dataForm.swear_history_execute_date)}
                                            </Col>
                                            
                                        </Row>
                                        <Row className="mb-3">
                                            <label
                                                htmlFor="name"
                                                className="col-md-3 col-form-label"
                                            >
                                                Dokumen Upload Surat Pernyataan Melaksanakan Tugas 
                                            </label>
                        
                                            <Col md="5">
                                            {this.state.dataForm?.swear_history_execute_doc_path?<a href={this.state.dataForm?.swear_history_execute_doc_path} className='btn btn-success btn-sm
 btn-sm' target={'_blank'} download><i class="uil-download-alt"></i> Download</a>:'-'}
                                            </Col>
                                            
                                        </Row>
                                        
                                        
                                        
                                        <Row className="mb-3">
                                            <Col md="3"></Col>
                                            <Col md="9">
                                                <Link to="/kepegawaian/home.html?riwayatsumpah">
                                                    <Button color="danger"><i className="uil-arrow-left"></i> Kembali</Button>
                                                </Link>
                                                {' '}
                                                
                                            </Col>
                                        </Row>
                                    </AvForm>
                                </CardBody>
                            </Card>
                        </Col>
                    </Row>
                </Container>
                <ConfirmAlert
                    confirmTitle="Konfirmasi!"
                    confirmInfo="Apakah anda yakin akan menyimpan data ini?"

                    loadingTitle="Mengirim data..."
                    loadingInfo="Tunggu beberapa saat"

                    successTitle="Berhasil!"
                    successInfo="Data berhasil disimpan"

                    failedTitle="Gagal!"
                    failedInfo="Data gagal disimpan"

                    showConfirm={this.state.confirm}
                    showLoading={this.state.loading}
                    showSuccess={this.state.success}
                    showFailed={this.state.failed}

                    response={this.confirmResponse}
                />
                { this.state.redirect ?
                    <Redirect to='/kepegawaian/home.html?riwayatsumpah'/>
                : null }
            </Fragment>
        )
    }

}

//export default IndexView
export default withRouter(IndexView);